import { AngularEditorConfig } from '@kolkov/angular-editor';

export const DATA_PER_PAGE = 5;

export const MAX_FILE_SIZE = 2097152;

export const MAX_FILEUPLOAD_SIZE = 10485760;

export const MAX_PDF_FILE_SIZE = 10485760;

// ************************** ERROR MESSAGES
export const SELECT_START_END_DATE_ERROR = "Please select Start Date and End Date";

export const END_YEAR_GREATER_THAN_START_YEAR_ERROR = 'End year should be greater than start year.';

export const NO_REPORTS_FOUND = 'No Reports found for the Selected Date';

export const Invalid_Youtube_Video_URL = 'Please enter valid url!, Invalid Youtube Video URL'

export const Invalid_URL = 'Please enter valid url'

export const Unsupported_file_format = 'Unsupported file format';

export const Maximum_file_size_540kb = 'Maximum image upload file size should be 540kb';

export const format_not_allowed = 'Selected file format is not allowed';

export const Max_file_size_10MB = 'Max file size exceeding 10MB cant be uploaded';

export const CANCEL = 'You choose to cancel';

export const Maximum_file_upload_size_should_be_10MB = 'Maximum file upload size should be 10MB';

export const Error_while_saving_the_data = 'Error while saving the data';

export const Maximum_image_upload_file_size_2mb = 'Maximum image upload file size should be 2mb';

export const Please_upload_Image = 'Please upload Image!';

export const Banner_deleted = 'Banner deleted';

export const Video_deleted = 'Video deleted';

export const Unsupported_PDF_format = 'Unsupported PDF format';

export const File_deleted = 'File deleted';

export const Please_upload_File = "Please upload File!"

export const File_uploaded = 'File uploaded';

export const Something_went_wrong = 'Something went wrong';

export const Data_deleted = 'Data deleted';

export const Sub_setion_deleted = 'Sub setion deleted';

export const Setion_deleted = 'Setion deleted';

// ************************** REPORTS
export const REPORT_TYPES = [
  {
    id: 0,
    name: 'ARN Report',
    type: 'ARN_REPORT',
    disabled: false,
  },
  {
    id: 1,
    name: 'Investor Feedback Report',
    type: 'INVESTOR_FEEDBACK_REPORT',
    disabled: false,
  },
  {
    id: 2,
    name: 'Distributor Transaction Report',
    type: 'TRANSACTION_REPORT',
    disabled: false,
  },
  {
    id: 3,
    name: 'Distributor Login Report',
    type: 'LOGIN_REPORT',
    disabled: false,
  },
  {
    id: 4,
    name: 'Unique Login Count',
    type: 'UNIQUE_LOGIN_COUNT_REPORT',
    disabled: false,
  },
  {
    id: 5,
    name: 'User Audit Report',
    type: 'AUDIT_REPORT',
    disabled: false,
  },
  {
    id: 6,
    name: 'User Session Report',
    type: 'USER_SESSION_REPORT',
    disabled: false,
  },
  {
    id: 7,
    name: 'Investor Transaction Report',
    type: 'INVESTOR_TRANSACTION_REPORT',
    disabled: false,
  },
  {
    id: 8,
    name: 'Investor Login Report',
    type: 'INVESTOR_LOGIN_REPORT',
    disabled: false,
  },
  {
    id: 9,
    name: 'User Rights Report ',
    type: 'USER_RIGHTS',
    disabled: false,
  },
  {
    id: 10,
    name: 'Online OTM Report ',
    type: 'ONLINE_OTM_REPORT',
    disabled: false,
  },
  {
    id: 10,
    name: 'SIP Cancellation & Pause Report',
    type: 'SIP_CANCELLATION_PAUSE',
    disabled: false,
  },
  
  
];

export const LOGIN_COUNT_SOURCE = [
  {
    value: 'W',
    name: 'Web',
  },
  {
    value: 'M',
    name: 'Mobile',
  },
];

export const BANNER_SECTIONS = [
  {
    name: 'Banners',
    value: 'BANNER',
  },
  {
    name: 'Fund Managers',
    value: 'FUND_MANAGER',
  },
  {
    name: 'Key Features',
    value: 'KEY_FEATURES',
  },
  {
    name: 'Banners for NFO',
    value: 'BANNER_NFO',
  },
  {
    name: 'Banners for CEO',
    value: 'BANNER_CEO',
  },
  {
    name: 'Banners for Careers',
    value: 'BANNER_CAREERS',
  },
];

/***CATALOUGE => VIDEOS */
export const VIDEO_SECTION_LIST = [
  {
    name: 'Product Video',
    value: 'PRODUCT_VIDEO',
  },
  {
    name: 'Investor Video',
    value: 'INVESTOR_VIDEO',
  },
];

/***CATALOUGE => ARTICLES */
export const ARTICLE_TYPE = [
  'Article',
  'News',
  'Media',
  'CEO-Library',
  'CEO-Interview',
  'Advertisement'
];

export const EditorConfig: AngularEditorConfig = {
  editable: true,
  spellcheck: true,
  height: 'auto',
  minHeight: '0',
  maxHeight: 'auto',
  width: 'auto',
  minWidth: '0',
  translate: 'yes',
  enableToolbar: true,
  showToolbar: true,
  placeholder: 'Add Description',
  defaultParagraphSeparator: '',
  defaultFontName: '',
  defaultFontSize: '',
  sanitize: true,
  toolbarHiddenButtons: [
    [],
    [
      'insertImage',
      'insertVideo',
      'insertHorizontalRule',
      'removeFormat',
      'link',
      'unlink',
      'customClasses',
      'textColor',
      'backgroundColor',
    ],
  ],
};

export const ARTICLE_CONTENT_TYPES = [
  {
    name: 'Image',
    value: 'IMAGE',
  },
  {
    name: 'PDF',
    value: 'PDF',
    disabled: false,
  },
  {
    name: 'Video or Link',
    value: 'VIDEO',
  },
];

export const CAREER_CONFIG_TYPES = [
  {
    name: 'Location',
    value: 'LOCATION',
  },
  {
    name: 'Department',
    value: 'DEPARTMENT',
  },
];

export const NAV_DIVEDEND_TYPE = [
  'NAV',
  'Dividend'
];

